import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
export default class MessagesPane extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.discussionId = String(vnode.attrs.initialDiscussionId || '');
    this.targetPostId = String(vnode.attrs.initialPostId || '');
    this.focusPostId = this.targetPostId ? Number(this.targetPostId) : null;
    this.discussion = null;
    this.filters = {
      author: '',
      status: 'all',
      q: '',
      title: '',
      tag_id: '',
      type: 'all'
    };
    if (vnode.attrs.initialAuthor) {
      this.filters.author = String(vnode.attrs.initialAuthor);
    }
    this.items = [];
    this.tags = [];
    this.selected = new Set();
    this.allMatching = false;
    this.total = 0;
    this.offset = 0;
    this.limit = 50;
    this.hasMore = false;
    this.loading = false;
    this.error = '';
    this.expanded = new Set();
    this.refreshTimer = null;
    this.search(true);
    this.refreshTimer = window.setInterval(() => {
      if (document.visibilityState !== 'visible' || this.loading) return;
      this.search(false);
    }, 30000);
  }
  onremove() {
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
    super.onremove();
  }
  api(path) {
    return String(app.forum.attribute('apiUrl') || '/api').replace(/\/$/, '') + path;
  }
  formatDate(value) {
    if (!value) return '—';
    try {
      return new Intl.DateTimeFormat('fr-FR', {
        dateStyle: 'short',
        timeStyle: 'short'
      }).format(new Date(value));
    } catch (e) {
      return value;
    }
  }
  forumLabel(item) {
    if (!Array.isArray(item.tags) || !item.tags.length) {
      return '—';
    }
    const child = item.tags.find(tag => tag.parent_id !== null);
    return (child || item.tags[0]).name;
  }
  discussionUrl(item) {
    const id = Number(item?.discussion?.id || 0);
    const number = Number(item?.number || 0);
    if (!id) return '#';
    return `/d/${id}${number ? `/${number}` : ''}`;
  }
  async search(resetOffset) {
    if (resetOffset === void 0) {
      resetOffset = true;
    }
    if (this.loading) return;
    if (resetOffset) {
      this.offset = 0;
      this.expanded.clear();
      this.selected.clear();
      this.allMatching = false;
    }
    this.loading = true;
    this.error = '';
    const qs = new URLSearchParams({
      status: this.filters.status,
      offset: String(this.offset),
      limit: String(this.limit),
      _: String(Date.now())
    });
    if (this.discussionId.trim()) {
      qs.set('discussion_id', this.discussionId.trim());
    }
    if (this.filters.author.trim()) {
      qs.set('author', this.filters.author.trim());
    }
    if (this.filters.q.trim()) {
      qs.set('q', this.filters.q.trim());
    }
    if (this.filters.title.trim()) {
      qs.set('title', this.filters.title.trim());
    }
    if (this.filters.tag_id) {
      qs.set('tag_id', this.filters.tag_id);
    }
    if (this.filters.type && this.filters.type !== 'all') {
      qs.set('type', this.filters.type);
    }
    if (resetOffset && this.targetPostId && this.discussionId) {
      qs.set('target_post_id', this.targetPostId);
    }
    try {
      const data = await app.request({
        method: 'GET',
        url: this.api('/val/moderation/posts?' + qs.toString())
      });
      this.discussion = data.discussion || null;
      this.items = data.items || [];
      this.tags = data.tags || [];
      this.total = Number(data.total || 0);
      this.offset = Number(data.offset || 0);
      this.hasMore = !!data.has_more;
      if (resetOffset && this.targetPostId && this.discussionId) {
        const targetId = Number(this.targetPostId);
        const target = this.items.find(item => Number(item.id) === targetId);
        if (target) {
          this.selected.add(target.id);
          this.expanded.add(target.id);
          this.focusPostId = target.id;
        } else if (data.target_found === false) {
          this.error = 'Le message demandé est introuvable ou n’est pas visible avec tes droits.';
        }
        this.targetPostId = '';
      }
    } catch (e) {
      this.items = [];
      this.tags = [];
      this.total = 0;
      this.hasMore = false;
      this.error = 'Impossible de charger les messages.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  toggleSelected(id) {
    this.allMatching = false;
    if (this.selected.has(id)) {
      this.selected.delete(id);
    } else {
      this.selected.add(id);
    }
  }
  allShownSelected() {
    return this.items.length > 0 && this.items.every(item => this.selected.has(item.id));
  }
  toggleAllShown() {
    this.allMatching = false;
    if (this.allShownSelected()) {
      this.items.forEach(item => this.selected.delete(item.id));
    } else {
      this.items.forEach(item => this.selected.add(item.id));
    }
  }
  toggleExpanded(id) {
    if (this.expanded.has(id)) {
      this.expanded.delete(id);
    } else {
      this.expanded.add(id);
    }
  }
  selectAllMatching() {
    if (!this.total) return;
    this.allMatching = true;
    this.selected.clear();
  }
  cancelAllMatching() {
    this.allMatching = false;
  }
  async contactPrivate(item) {
    if (this.loading || !item || !item.user_id || !item.username || !app.session.user || !app.forum.attribute('canStartPrivateDiscussion')) {
      return;
    }
    this.loading = true;
    this.error = '';
    try {
      let recipient = app.store.getById('users', String(item.user_id));
      if (!recipient) {
        recipient = await app.store.find('users', String(item.user_id));
      }
      if (!recipient) {
        this.error = 'Ce membre est introuvable.';
        return;
      }
      const discussionId = Number(item.discussion?.id || 0);
      const postNumber = Number(item.number || 0);
      const postId = Number(item.id || 0);
      const redirect = app.route('val-moderation') + '?tab=messages&discussion_id=' + encodeURIComponent(discussionId) + '&post_id=' + encodeURIComponent(postId);
      const discussionTitle = String(item.discussion?.title || '').trim() || `Discussion #${discussionId}`;
      const rawTitle = 'À propos de votre message dans « ' + discussionTitle + ' »';
      const title = rawTitle.length > 80 ? rawTitle.slice(0, 77) + '…' : rawTitle;
      const content = 'Bonjour @' + item.username + ',\n\n' + 'À propos de votre message : [voir le message](/d/' + discussionId + '/' + postNumber + ')\n\n';
      const params = [['recipientUsers', String(item.user_id)], ['title', title], ['content', content], ['redirect', redirect]].map(_ref => {
        let [key, value] = _ref;
        return encodeURIComponent(key) + '=' + encodeURIComponent(value);
      }).join('&');
      m.route.set(app.route('byobuComposer') + '?' + params);
      let attempts = 0;
      const applyTitle = () => {
        const titleField = app.composer?.fields?.title;
        if (typeof titleField === 'function') {
          titleField(title);
          m.redraw();
          return;
        }
        attempts += 1;
        if (attempts < 20) {
          window.setTimeout(applyTitle, 50);
        }
      };
      window.setTimeout(applyTitle, 0);
    } catch (e) {
      this.error = 'Impossible d’ouvrir la discussion privée avec ce membre.';
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  async runAction(action) {
    if (this.loading || !this.selected.size && !this.allMatching) {
      return;
    }
    const selectedItems = this.items.filter(item => this.selected.has(item.id));
    const includesFirstPost = this.allMatching || selectedItems.some(item => item.is_first_post);
    const label = action === 'hide' ? 'masquer' : action === 'delete' ? 'supprimer définitivement' : 'restaurer';
    const count = this.allMatching ? this.total : this.selected.size;
    if (action === 'delete' && !confirm(`ATTENTION : suppression définitive de ${count} message${count > 1 ? 's' : ''}.\n\nCette action est irréversible. Continuer ?`)) {
      return;
    }
    if (!confirm(this.allMatching ? `Confirmer : ${label} TOUS les ${count.toLocaleString('fr-FR')} messages correspondant aux filtres ?` : `Confirmer : ${label} ${count} message${count > 1 ? 's' : ''} ?`)) {
      return;
    }
    let allowFirstPost = false;
    if (includesFirstPost) {
      allowFirstPost = confirm('ATTENTION : le premier message de la discussion est sélectionné. ' + 'Confirmer explicitement que cette action doit aussi s’appliquer au premier message ?');
      if (!allowFirstPost) {
        return;
      }
    }
    this.loading = true;
    this.error = '';
    try {
      const data = await app.request({
        method: 'POST',
        url: this.api('/val/moderation/posts/actions'),
        body: {
          action: action,
          discussion_id: this.discussion?.id || null,
          ids: Array.from(this.selected),
          all_matching: this.allMatching,
          allow_first_post: allowFirstPost,
          status: this.filters.status,
          author: this.filters.author,
          q: this.filters.q,
          title: this.filters.title,
          tag_id: this.filters.tag_id
        }
      });
      this.selected.clear();
      this.allMatching = false;
      alert(`${data.changed || 0} modifié(s)` + (data.unchanged ? ` · ${data.unchanged} déjà dans cet état` : '') + (data.denied ? ` · ${data.denied} refusé(s)` : '') + (data.protected ? ` · ${data.protected} premier message protégé` : ''));
    } catch (e) {
      const detail = e?.response?.errors?.[0]?.detail || e?.response?.error || '';
      this.error = detail ? `L’action n’a pas pu être exécutée : ${detail}` : 'L’action n’a pas pu être exécutée.';
    } finally {
      this.loading = false;
    }
    await this.search(false);
  }
  previousPage() {
    if (this.offset <= 0 || this.loading) return;
    this.offset = Math.max(0, this.offset - this.limit);
    this.search(false);
  }
  nextPage() {
    if (!this.hasMore || this.loading) return;
    this.offset += this.limit;
    this.search(false);
  }
  goToPage(page) {
    if (this.loading) return;
    const pages = Math.max(1, Math.ceil(this.total / this.limit));
    page = Math.max(1, Math.min(pages, Number(page) || 1));
    const offset = (page - 1) * this.limit;
    if (offset === this.offset) return;
    this.offset = offset;
    this.search(false);
  }
  pagination() {
    var _this = this;
    const pages = Math.max(1, Math.ceil(this.total / this.limit));
    if (pages <= 1) return null;
    const current = Math.floor(this.offset / this.limit) + 1;

    /*
     * Fenêtre glissante de 10 pages.
     */
    const maxStart = Math.max(1, pages - 9);
    const start = Math.max(1, Math.min(current - 4, maxStart));
    const end = Math.min(pages, start + 9);
    const buttons = [];
    const button = function (label, page, disabled, active, title) {
      if (disabled === void 0) {
        disabled = false;
      }
      if (active === void 0) {
        active = false;
      }
      if (title === void 0) {
        title = '';
      }
      return m(active ? 'button.Button.Button--primary' : 'button.Button', {
        type: 'button',
        disabled: disabled || _this.loading,
        title,
        onclick: () => _this.goToPage(page)
      }, label);
    };
    buttons.push(button('Début', 1, current <= 1, false, 'Première page'));
    buttons.push(button('‹', current - 1, current <= 1, false, 'Page précédente'));
    for (let page = start; page <= end; page++) {
      buttons.push(button(String(page), page, false, page === current, 'Page ' + page));
    }
    buttons.push(m('form.ValModerationPageJump', {
      onsubmit: event => {
        event.preventDefault();
        const input = event.currentTarget.querySelector('input');
        const page = Number(input?.value || current);
        this.goToPage(page);
      }
    }, [m('span', 'Page'), m('input.FormControl', {
      type: 'number',
      min: 1,
      max: pages,
      step: 1,
      value: current,
      'aria-label': 'Numéro de page'
    }), m('span', '/ ' + pages), m('button.Button', {
      type: 'submit',
      disabled: this.loading
    }, 'Aller')]));
    buttons.push(button('›', current + 1, current >= pages, false, 'Page suivante'));
    buttons.push(button('Dernière', pages, current >= pages, false, 'Dernière page'));
    return m('.ValModerationPagination', buttons);
  }
  view() {
    const first = this.total ? this.offset + 1 : 0;
    const last = Math.min(this.offset + this.items.length, this.total);
    return m('.ValModerationMessages', [m('form.ValModerationFilters', {
      onsubmit: e => {
        e.preventDefault();
        this.search(true);
      }
    }, [m('.ValModerationFilters-grid', [m('label.ValModerationField', [m('span', 'Recherche'), m('input.FormControl', {
      type: 'text',
      value: this.filters.q,
      placeholder: 'Dans les messages…',
      oninput: e => {
        this.filters.q = e.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Discussion ID'), m('input.FormControl', {
      type: 'number',
      min: 1,
      value: this.discussionId,
      placeholder: 'Facultatif',
      oninput: e => {
        this.discussionId = e.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Titre discussion'), m('input.FormControl', {
      type: 'text',
      value: this.filters.title,
      placeholder: 'Facultatif',
      oninput: e => {
        this.filters.title = e.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Auteur'), m('input.FormControl', {
      type: 'text',
      value: this.filters.author,
      placeholder: 'Pseudo ou ID',
      oninput: e => {
        this.filters.author = e.target.value;
      }
    })]), m('label.ValModerationField', [m('span', 'Forum'), m('select.FormControl', {
      value: this.filters.tag_id,
      onchange: e => {
        this.filters.tag_id = e.target.value;
      }
    }, [m('option', {
      value: ''
    }, 'Tous les forums'), ...this.tags.map(tag => m('option', {
      value: String(tag.id)
    }, `${'\u00a0\u00a0'.repeat(tag.depth || 0)}${tag.name}`))])]), m('label.ValModerationField', [m('span', 'Type'), m('select.FormControl', {
      value: this.filters.type,
      onchange: e => {
        this.filters.type = e.target.value;
      }
    }, [m('option', {
      value: 'all'
    }, 'Tous les messages'), m('option', {
      value: 'public'
    }, 'Messages publics'), m('option', {
      value: 'private'
    }, 'Messages privés (MP)')])]), m('label.ValModerationField', [m('span', 'État'), m('select.FormControl', {
      value: this.filters.status,
      onchange: e => {
        this.filters.status = e.target.value;
      }
    }, [m('option', {
      value: 'all'
    }, 'Tous'), m('option', {
      value: 'visible'
    }, 'Visibles'), m('option', {
      value: 'hidden'
    }, 'Masqués')])])]), m('.ValModerationFilters-actions', [m('button.Button.Button--primary', {
      type: 'submit',
      disabled: this.loading
    }, this.loading ? 'Chargement…' : 'Afficher les messages')])]), this.error ? m('.Alert.Alert--error', this.error) : null, m('.ValModerationResultsHeader', [m('strong', this.discussion ? `Discussion #${this.discussion.id} — ${this.discussion.title}` : 'Messages récents'), m('span', (this.allMatching ? `Tous les ${this.total.toLocaleString('fr-FR')} correspondants sélectionnés` : `${this.selected.size.toLocaleString('fr-FR')} sélectionné${this.selected.size > 1 ? 's' : ''}`) + (this.total ? ` · ${this.total.toLocaleString('fr-FR')} message${this.total > 1 ? 's' : ''}` + ` · Résultats ${first.toLocaleString('fr-FR')} à ${last.toLocaleString('fr-FR')}` : ''))]), m('.ValModerationActions', [!this.allMatching && this.total > this.selected.size ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.selectAllMatching()
    }, `Sélectionner les ${this.total.toLocaleString('fr-FR')} résultats`) : null, this.allMatching ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.cancelAllMatching()
    }, 'Annuler la sélection globale') : null, m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('hide')
    }, 'Masquer'), m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('restore')
    }, 'Restaurer'), m('button.Button.Button--danger', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('delete')
    }, 'Supprimer définitivement')]), m('.ValModerationTableWrap', m('table.ValModerationTable', [m('thead', m('tr', [m('th.ValModerationTable-check', m('input', {
      type: 'checkbox',
      checked: this.allShownSelected(),
      disabled: !this.items.length,
      onchange: () => this.toggleAllShown()
    })), m('th.ValModerationTable-number', '#'), m('th.ValModerationTable-id', 'ID'), m('th', 'Auteur'), m('th', 'Date'), m('th', 'Discussion'), m('th', 'Forum'), m('th', 'Message'), m('th', 'État'), m('th.ValModerationTable-actions', 'Actions')])), m('tbody', this.items.length ? this.items.flatMap(item => {
      const rows = [m('tr', {
        key: `post-${item.id}`,
        className: this.focusPostId === item.id ? 'is-targeted' : '',
        oncreate: vnode => {
          if (this.focusPostId === item.id) {
            requestAnimationFrame(() => {
              vnode.dom.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              });
            });
          }
        }
      }, [m('td.ValModerationTable-check', m('input', {
        type: 'checkbox',
        checked: this.selected.has(item.id),
        onchange: () => this.toggleSelected(item.id)
      })), m('td.ValModerationTable-number', String(item.number)), m('td.ValModerationTable-id', String(item.id)), m('td', item.username || 'Ancien membre'), m('td', this.formatDate(item.created_at)), m('td', [item.discussion ? m('a', {
        href: this.discussionUrl(item),
        onclick: e => {
          e.preventDefault();
          m.route.set(this.discussionUrl(item));
        }
      }, item.discussion.title) : '—']), m('td', this.forumLabel(item)), m('td', item.excerpt || '—'), m('td.ValModerationTable-status', item.hidden_at ? m('span.ValModerationStatus.is-hidden', 'Masqué') : m('span.ValModerationStatus.is-visible', 'Visible')), m('td.ValModerationTable-actions', [m('button.Button.Button--link.ValModerationExpandButton', {
        type: 'button',
        onclick: () => this.toggleExpanded(item.id)
      }, this.expanded.has(item.id) ? 'Replier' : 'Déplier'), item.user_id && item.username && app.forum.attribute('canStartPrivateDiscussion') ? m('button.Button.Button--link.ValModerationExpandButton', {
        type: 'button',
        title: `Ouvrir une discussion privée avec ${item.username}`,
        onclick: () => this.contactPrivate(item)
      }, 'Contacter en privé') : null])])];
      if (this.expanded.has(item.id)) {
        rows.push(m('tr', {
          key: `content-${item.id}`
        }, m('td', {
          colspan: 10
        }, m('.ValModerationMessageContent', {
          oncreate: vnode => {
            vnode.dom.innerHTML = item.content_html || '';
          },
          onupdate: vnode => {
            vnode.dom.innerHTML = item.content_html || '';
          }
        }))));
      }
      return rows;
    }) : m('tr', m('td', {
      colspan: 10
    }, 'Aucun message trouvé.')))])), m('.ValModerationActions', [!this.allMatching && this.total > this.selected.size ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.selectAllMatching()
    }, `Sélectionner les ${this.total.toLocaleString('fr-FR')} résultats`) : null, this.allMatching ? m('button.Button', {
      type: 'button',
      disabled: this.loading,
      onclick: () => this.cancelAllMatching()
    }, 'Annuler la sélection globale') : null, m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('hide')
    }, 'Masquer'), m('button.Button', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('restore')
    }, 'Restaurer'), m('button.Button.Button--danger', {
      type: 'button',
      disabled: !this.selected.size && !this.allMatching || this.loading,
      onclick: () => this.runAction('delete')
    }, 'Supprimer définitivement')]), this.pagination()]);
  }
}